// extracted by mini-css-extract-plugin
export default {"trigger":"Tooltip_trigger__45AXD","tooltip":"Tooltip_tooltip__O3RKo"};